import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';

import {
  CustomerList,
  ProductList,
  VehicleList,
} from '@C/CreditCustomers/_utils/';
import ExcelJS from 'exceljs';
import services from '@C/CreditCustomers/_utils/data';
import TableToExcelExport from '@C/TableToExcelExport';
import { InterFont } from '@C/TableGrid';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { getBase64FromUrl } from '@C/Utils/ExportUtils';
import { ShiftsList, StaffList } from '@C/Utils';
import { authHeader } from '@H';
import { authService } from '@S';
import SlipList from './slipList';
import BalanceList from './balanceList';
import { Pagination } from '@C/Utils';

class CustomerLedger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slipList: [],
      balanceList: [],
      selectedId: '',
      showModal: false,
      staff_id: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      product_id: '',
      customer_id: '',
      shift_id: '',
      slip_no: '',
      vehicle_number: '',
      loading: true,
      productList: this.props.products,
      customerList: this.props.customers,
      limit: 20,
      offset: 1,
      count: 0,
    };

    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.setState({ loading: true }, this.getCreditLedger);
  }

  getCreditLedger = () => {
    this.setState({ loading: true });
    services
      .getCreditLedger(this.state)
      .then((response) => {
        const tmp = response.data.data;
        this.setState({
          slipList: tmp.results,
          balanceList: tmp.balances,
          count: tmp.count,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleShiftChange = (e) => {
    this.setState({ shift_id: e.value });
  };

  handleStaffChange = (e) => {
    this.setState({ staff_id: e.value });
  };

  handleBillChange = (e) => {
    this.setState({ slip_no: e.target.value });
  };

  handleProductChange = (e) => {
    this.setState({ product_id: e?.value || '' });
  };

  handleCustomerChange = (e) => {
    this.setState({ customer_id: e.value });
  };

  handleVehicleChange = (e) => {
    this.setState({ vehicle_number: e?.value || '' });
  };

  handleCategoryChange = (e) => {
    this.setState({ customer_id: e });
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getCreditLedger();
      },
    );
  };
  editItem = (selectedId) => {
    this.setState({ selectedId: selectedId, showModal: true });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  resetFilter = () => {
    this.setState(
      {
        staff_id: '',
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        product_id: '',
        customer_id: '',
        shift_id: '',
        loading: true,
        slip_number: '',
        vehicle_number: '',
      },
      function () {
        this.getCreditLedger();
      },
    );
  };

  confirmDelete = (id) => {
    confirmAlert({
      title: 'Confirm sale deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(id),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (id) => {
    const headers = authHeader(1);
    axios
      .delete(`${process.env.API_URL}/payment/?transaction_id=${id}`, {
        headers,
      })
      .then((response) => {
        toast.success('Sale deleted successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        this.getCreditLedger();
      });
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getCreditLedger();
    });
  };

  export2PDF = () => {
    const doc = new jsPDF();
    const start_date = this.state.start_date;
    const end_date = this.state.end_date;
    doc.addFileToVFS('Inter-Regular.ttf', InterFont);
    doc.addFont('Inter-Regular.ttf', 'Inter', 'normal');
    doc.setFont('Inter');

    const exportOptions = {
      fileName: `Customer Ledger- ${start_date} to ${end_date} Report.pdf`,
      reportName: 'Customer Ledger Report',
      reportDate: `Date - ${dayjs(start_date).format('D MMM YY')} to ${dayjs(end_date).format('D MMM YY')}`,
    };
    const omcLogo = getBase64FromUrl(authService.currentOMCWebLogo);
    const bunkAddress = authService.currentBunkAddress;
    const slipList = this.state.slipList;
    omcLogo.then((result) => {
      const img = new Image();
      img.onload = function () {
        doc.addFileToVFS('Inter-Regular.ttf', InterFont);
        doc.addFont('Inter-Regular.ttf', 'Inter', 'normal');
        doc.setFont('Inter');
        const aspectRatio = img.width / img.height;
        const width = 25;
        const height = width / aspectRatio;
        try {
          doc.addImage(result, 'PNG', 13, 10, width, height);
          autoTable(doc, {
            body: [
              [
                {
                  content: authService.currentBunkName,
                  styles: {
                    halign: 'right',
                    fontSize: 15,
                    textColor: '#000000',
                  },
                },
              ],
              [
                {
                  content:
                    bunkAddress.city +
                    ', ' +
                    bunkAddress.location +
                    ',' +
                    bunkAddress.country.country +
                    ' - ' +
                    bunkAddress.pincode,
                  styles: {
                    halign: 'right',
                    fontSize: 12,
                    textColor: '#000000',
                  },
                },
              ],
            ],
            theme: 'plain',
          });
          autoTable(doc, {
            body: [
              [
                {
                  content: 'Customer Ledger Report',
                  styles: {
                    halign: 'left',
                    fontSize: 15,
                    textColor: '#000000',
                    fontStyle: 'bold',
                  },
                },
                {
                  content: `${dayjs(start_date).format('D MMM YY')} to ${dayjs(end_date).format('D MMM YY')}`,
                  styles: {
                    halign: 'right',
                    fontSize: 12,
                    textColor: '#000000',
                    fontStyle: 'bold',
                  },
                },
              ],
              [
                {
                  content: `${slipList[0]?.customer?.first_name} ${slipList[0]?.customer?.last_name}`,
                  styles: {
                    halign: 'left',
                    fontSize: 12,
                    textColor: '#000000',
                    fontStyle: 'bold',
                  },
                },
              ],
            ],
            theme: 'plain',
          });

          const tables = document.querySelectorAll('table');
          tables.forEach((table, i) => {
            const startY = doc.lastAutoTable
              ? doc.lastAutoTable.finalY + 10
              : 40;
            autoTable(doc, {
              html: table,
              startY: startY,
              pageBreak: 'auto',
              theme: 'grid',
              styles: {
                font: 'Inter',
                overflow: 'linebreak',
                fontSize: 9,
                cellWidth: 'auto',
              },
              margin: { top: 15, right: 5, bottom: 5, left: 5 },
            });
          });

          // Adding final summary table at the end of all tables
          autoTable(doc, {
            body: [
              [
                {
                  content: `Total outstanding amount -  ${parseFloat(slipList[0]?.balance).toFixed(2) || 0}`,
                  styles: {
                    halign: 'right',
                    fontSize: 10,
                    textColor: '#000000',
                  },
                },
              ],
              [
                {
                  content: `Total amount -  ${
                    slipList.reduce((a, b) => a + (b['amount'] || 0), 0) ||
                    (0).toFixed(2) ||
                    0
                  }`,
                  styles: {
                    halign: 'right',
                    fontSize: 10,
                    textColor: '#000000',
                  },
                },
              ],
              [
                {
                  content: `Total amount received -  ${
                    slipList.reduce(
                      (a, b) => a + (b['amount_received'] || 0),
                      0,
                    ) ||
                    (0).toFixed(2) ||
                    0
                  }`,
                  styles: {
                    halign: 'right',
                    fontSize: 10,
                    textColor: '#000000',
                  },
                },
              ],
            ],
            theme: 'plain',
            startY: doc.lastAutoTable.finalY + 10,
          });

          doc.save(
            `${authService.currentBunkName} - ${exportOptions.fileName}`,
          );
        } catch (e) {
          console.log(e);
        }
      };
      img.src = result;
    });
  };

  export2Excel = () => {
    const start_date = this.state.start_date;
    const end_date = this.state.end_date;
    let book;
    const tables = document.querySelectorAll('table');
    tables.forEach((table, i) => {
      const sheetName = table.getAttribute('data-name');

      if (i === 0) {
        book = TableToExcelExport.tableToBook(table, {
          sheet: { name: sheetName },
        });
      } else {
        TableToExcelExport.tableToSheet(book, table, {
          sheet: { name: sheetName },
        });
      }
    });
    TableToExcelExport.save(
      book,
      `${authService.currentBunkName} - Customer Ledger - ${start_date} to ${end_date}.xlsx`,
    );
  };

  handlePagination = (e) => {
    this.setState({ offset: e }, function () {
      this.getCreditLedger();
    });
  };
  render() {
    const { slipList } = this.state;
    return (
      <section className="widget full-width list-table">
        <header>
          <h3>Customer Ledger</h3>
        </header>
        <main>
          <div className="table-filters">
            <div className="filter-wrapper">
              <div className="filter-group with-icon">
                <label>Results to display - (Total: {this.state.count})</label>
                <form onSubmit={this.handleQuickSearch}>
                  <input type="text" name="limit" ref={this.limitInput} />
                  <button
                    type="submit"
                    className="search-icon"
                    onClick={this.handleQuickSearch}
                  />
                </form>
              </div>
              <div className="filter-group">
                <label>From date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.start_date}
                  name="start_date"
                  onChange={this.handleDateChange}
                />
              </div>
              <div className="filter-group">
                <label>To date:</label>
                <input
                  className="cstm-date-input"
                  type="date"
                  value={this.state.end_date}
                  min={this.state.start_date}
                  onChange={this.handleDateChange}
                  name="end_date"
                />
              </div>
              <div className="filter-group">
                <label>Staff:</label>
                <StaffList
                  value={this.state.staff_id}
                  onChange={this.handleStaffChange}
                  staffType={['Cashiers', 'Managers', 'Dealer']}
                />
              </div>
              <div className="filter-group">
                <label>Shift:</label>
                <ShiftsList
                  value={this.state.shift_id}
                  onChange={this.handleShiftChange}
                />
              </div>
              <div className="filter-group">
                <label>Product:</label>
                <ProductList
                  onProductChange={this.handleProductChange}
                  value={this.state.product_id}
                  options={this.state.productList}
                />
              </div>
              <div className="filter-group">
                <label>Customer:</label>
                <CustomerList
                  onCustomerChange={this.handleCustomerChange}
                  value={this.state.customer_id}
                  options={this.state.customerList}
                />
              </div>
              <div className="filter-group">
                <label>Vehicle:</label>
                <VehicleList
                  value={this.state.vehicle_number}
                  handleDropdownChange={this.handleVehicleChange}
                  selectedCustomerId={this.state.customer_id}
                />
              </div>
              <div className="filter-group reset-filter">
                <button onClick={this.resetFilter}>Reset filters</button>
              </div>
              <div className="form-actions">
                <button
                  className="submit"
                  type="submit"
                  onClick={this.submitForm}
                >
                  Apply filter
                </button>
              </div>
              <div className="filter-group">
                <button
                  className="blue-btn btn-with-icon btn-with-icon__excel action-btn "
                  onClick={() => this.export2Excel()}
                  title="Export to Excel"
                >
                  Export to Excel
                </button>
              </div>
              <div className="filter-group">
                <button
                  className="blue-btn btn-with-icon btn-with-icon__pdf action-btn "
                  onClick={() => this.export2PDF()}
                  title="Export to PDF"
                >
                  Export to PDF
                </button>
              </div>
            </div>
          </div>
          <div className="tg-wrapper">
            {(() => {
              if (this.state.loading) {
                return <DropLoaderLarge />;
              } else {
                return (
                  <>
                    {this.state.customer_id && (
                      <div className="mini-summary">
                        <ul>
                          <li>
                            <span> Total outstanding amount: </span>
                            <span>
                              {new Intl.NumberFormat('en-IN', {}).format(
                                parseFloat(slipList[0]?.balance).toFixed(2) ||
                                  0,
                              )}
                            </span>
                          </li>
                        </ul>
                      </div>
                    )}
                    <div className="mini-summary">
                      <ul>
                        <li>
                          <span> Total amount: </span>
                          <span>
                            {new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                            }).format(
                              slipList.reduce(
                                (a, b) => a + (b['amount'] || 0),
                                0,
                              ) || 0,
                            )}
                          </span>
                        </li>
                        <li>
                          <span> Total amount received: </span>
                          <span>
                            {new Intl.NumberFormat('en-IN', {
                              style: 'currency',
                              currency: 'INR',
                            }).format(
                              slipList.reduce(
                                (a, b) => a + (b['amount_received'] || 0),
                                0,
                              ) || 0,
                            )}
                          </span>
                        </li>
                      </ul>
                    </div>
                    <div className="tg-actions">
                      <ul>
                        <li>
                          <span> Total records: </span>
                          <span>{this.state.count || 0} </span>
                        </li>
                      </ul>
                    </div>
                    <SlipList summary={this.state.slipList} />
                    <BalanceList summary={this.state.balanceList} />
                  </>
                );
              }
            })()}
            <Pagination
              handlePagination={this.handlePagination}
              count={this.state.count}
              limit={this.state.limit}
              offset={this.state.offset}
            />
          </div>
        </main>
      </section>
    );
  }
}

export { CustomerLedger };
